module.exports = __webpack_public_path__ + "img/program-disclaimer.a8701bf5.png";